import * as React from "react";

function SvgLinkedin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M5.33 2.67A2.52 2.52 0 012.67 5.3 2.53 2.53 0 010 2.74 2.62 2.62 0 012.67 0a2.58 2.58 0 012.66 2.67zM0 24V6.67h5.33V24zM8 12.59c0-2.06-.07-3.78-.14-5.27h4.8l.23 2.3H13A5.94 5.94 0 0118.09 7C21.47 7 24 9.21 24 14.08V24h-5.33v-9.15c0-2.12-.81-3.74-2.67-3.74a2.78 2.78 0 00-2.5 2.09 3.82 3.82 0 00-.17 1.28V24H8z" />
    </svg>
  );
}

const MemoSvgLinkedin = React.memo(SvgLinkedin);
export default MemoSvgLinkedin;
